export default function (file) {
  const sendEvent = this.sendEvent
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()

      // reads content Blob, transform it to base64 & fires onload callback
      reader.readAsDataURL(file.content)

      reader.onload = function () {
        // send event
        sendEvent('download', {
          ...file,
          filename: file.filename.replace(/\//g, '_'),
          content: this.result.replace(/^data:(application|image)\/.+;base64,/, ''),
        })

        // done
        resolve()
      }
    } catch (e) {
      // something went wrong
      reject(e)
    }
  })
}
